import Card from "./Card";

const MasterCardReview = () => {

    return (
        <>
        <section class="cards-section lemon-green" id="audit">
            <div class="container">
                <h2 class="section-title">Customer review</h2>
                <div class="cards-grid">
                    <Card header="Worth purchasing" para="Satisfied with the product." badge="*****"/>
                    <Card header="Nice product" para="Awesome quality." badge="*****"/>
                    <Card header="Durable" para="Product is durable" badge="****"/>
                </div>
            </div>
        </section>
        </>
    );
}

export default MasterCardReview;